import aghapi from '../../api/aghapi.js'

const CORP_CUSTOMIZE='CORP_CUSTOMIZE'
const CORP_CUSTOMIZE_ATTR = 'CORP_CUSTOMIZE_ATTR'

const state = {
    corpCustomize:{},
    m_home_care_title:'',
    m_home_care_number:'',
    m_home_nav_care_text:'',
    m_home_nav_care_url:'',
    page_title:'',
    page_title_default: '',
    m_home:'',
    welfare_notify_description:'',
    help_jifen:'1',
    customize_loaded:false,
}
const getters = {
    getCorpCustomize:state=>{return state.corpCustomize},
    getCustomizeMHomeCareTitle:state=>{return state.m_home_care_title},
    getCustomizeMHomeCareNumber:state=>{return state.m_home_care_number},
    getCustomizeMHomeNavCareText:state=>{return state.m_home_nav_care_text},
    getCustomizeMHomeNavCareUrl:state=>{return state.m_home_nav_care_url},
    getCustomizePageTitle:state=>{return state.page_title},
    getCustomizeMHome:state=>{return state.m_home},
    getCustomizeWelfareNotifyDescription:state=>{return state.welfare_notify_description},
    getCustomizeHelpJifen:state=>{return state.help_jifen},
}

const actions = {
    getCorpCustomize({commit},params){
        aghapi.getCorpCustomize(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                commit(CORP_CUSTOMIZE,{data:res.data.body})
                for(let key in res.data.body){
                    commit(CORP_CUSTOMIZE_ATTR,{data:res.data.body[key]})
                }
                commit(CORP_CUSTOMIZE_ATTR,{data:{'key':'customize_loaded','value':true}})
            }
        })
    },
}

// mutations
const mutations = {
    [CORP_CUSTOMIZE](state, { data }) {
        state.corpCustomize = data
    },
    [CORP_CUSTOMIZE_ATTR](state, { data }) {
        state[data.key] = data.value
    },
}
export default {
    state,
    getters,
    actions,
    mutations
}